//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBobContactController_suggestBobId,
  Response$AdminBobContactController_suggestBobId$Status$200,
  ResponseContentType$AdminBobContactController_suggestBobId,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBobContactController_suggestBobId = (options: {
  params: Params$AdminBobContactController_suggestBobId['parameter'];
  config?: QueryOptions<
    Response$AdminBobContactController_suggestBobId$Status$200[ResponseContentType$AdminBobContactController_suggestBobId]
  >;
}) =>
  useApiClient<
    Params$AdminBobContactController_suggestBobId,
    Response$AdminBobContactController_suggestBobId$Status$200[ResponseContentType$AdminBobContactController_suggestBobId]
  >({
    method: 'AdminBobContactController_suggestBobId',
    params: { parameter: options.params },
    config: options.config,
  });
